import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'
import { TestimonialsProps } from 'lib/components/Testimonials/Testimonials'

import { IconListItem } from '@/components/IconList'

export interface PartnershipBenefitsPageContent {
  hero: NarrativeHeroProps
  fifties: FiftyFiftyProps[]
  partnershipTestimonials: TestimonialsProps
  whatInItForYouHeader: string
  whatInItForYouList: IconListItem[]
  whatDoesItMeanHeader: string
  whatDoesItMeanList: IconListItem[]
}

const BACKGROUND_IMAGE = '/images/shipsticks/partner-background.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Become a partner',
  subHeader: 'A better experience - for you, your guests, and your team.',
}

const fifties: FiftyFiftyProps[] = [
  {
    image: {
      src: '/images/shipsticks/partner-1.jpg',
    },
    backgroundColor: 'grey',
    header: 'Become a partner',
    layout: 'image-right',
    button: {
      text: 'Become a partner',
      link: {
        href: '#lead-form',
      },
    },
    body: `
            By joining forces with ShipSticks, you're giving your guests a
            better experience right from the start - and giving your team a
            simpler way to support them.`,
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipsticks/partner-2.jpg',
    },
    backgroundColor: 'grey',
    header: "You're in good company",
    layout: 'image-left',
    body: `
            We partner with more than 3,500 golf destinations around the world,
            from Bandon Dunes and Pebble Beach to Pinehurst and Troon-managed
            properties. They trust us to deliver exceptional service. You can,
            too.
          `,
    showEyebrow: false,
  },
]

const partnershipTestimonials: TestimonialsProps = {
  title: (
    <>
      What our partners <strong>have&nbsp;to&nbsp;say</strong>
    </>
  ),
  testimonials: [
    {
      stars: 5,
      quote: `Guests can easily ship their clubs and Pebble Beach purchases right
       to their doorstep, making travel to and from the resort truly seamless.
        It's one less thing they have to think about, and it adds to the elevated,
         worry-free experience we aim to deliver`,
      attribution: {
        icon: 'golf',
        name: 'Travis E',
        location: 'Pebble Beach Resorts E-Commerce Manager',
      },
    },
    {
      stars: 5,
      quote: `For many, playing the courses at Pebble Beach Resorts is a
        bucket list venture... Knowing their clubs will be waiting
        for them sets the tone for our guests before they even set foot on property`,
      attribution: {
        icon: 'golf',
        name: 'Lauren G.',
        location: 'The Inn at Spanish Bay Director of Rooms',
      },
    },
  ],
}

const whatInItForYouHeader: string = "What's in it for you?"

const whatInItForYouList: IconListItem[] = [
  {
    icon: 'check-circle-filled',
    header: 'Added value without added work',
    body: (
      <>
        We handle the shipping logistics. You deliver the experience. Our team supports your staff
        every step of the way.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Onsite signage & digital resources',
    body: (
      <>
        From custom landing pages to co-branded materials, we make integration easy and effortless
        for your team.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Revenue opportunities',
    body: (
      <>
        Earn commission on every shipment placed through your channel, along with discounted
        shipping
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Increased guest satisfaction',
    body: (
      <>
        Set the tone for a standout stay by offering a premium, hassle-free shipping option that
        your guests will thank you for.
      </>
    ),
  },
]

const whatDoesItMeanHeader: string = 'What does that mean for your guests?'

const whatDoesItMeanList: IconListItem[] = [
  {
    icon: 'check-circle-filled',
    header: 'Stress-free travel',
    body: (
      <>
        No more lugging golf clubs through airports or squeezing them into rental cars. Guests enjoy
        seamless door-to-door shipping, arriving fresh and ready to play.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Trusted by golfers worldwide',
    body: (
      <>
        With millions of bags shipped and thousands of golf trips made easier, ShipSticks is the
        most trusted name in golf travel.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Premium experience',
    body: (
      <>
        Real-time tracking, insurance options, and top-tier customer support mean your guests
        receive 5-star treatment from start to finish.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Travel light, arrive happy',
    body: (
      <>
        When their clubs are already waiting at the first tee, the vacation starts sooner and lasts
        longer.
      </>
    ),
  },
]

const content: PartnershipBenefitsPageContent = {
  hero,
  fifties,
  partnershipTestimonials,
  whatInItForYouHeader,
  whatInItForYouList,
  whatDoesItMeanHeader,
  whatDoesItMeanList,
}

export default content
